import { environmentBase } from './environment-base';

export const environmentBasePartenaires = Object.assign(environmentBase, {
  apiUrl:  {
    waterChart: {
      moderateUrl: `https://services3.arcgis.com/0lL78GhXbg1Po7WO/arcgis/rest/services/FS_PROD_Median_Hydrogrammes/FeatureServer/300/query/?f=json&outFields=Date,Prevision,Heure&where=TronconID=`,
      highUrl: `/apis/esri3-feature-services/0lL78GhXbg1Po7WO/arcgis/rest/services/FS_PROD_Fort_Hydrogrammes/FeatureServer/200/query/?f=json&outFields=Date,Prevision,Heure&where=TronconID=`
    },
    tronconQueryUrl: {
      M1: `https://services3.arcgis.com/0lL78GhXbg1Po7WO/arcgis/rest/services/FS_PROD_Median_Jour1/FeatureServer/101/query/?f=json&outFields=Troncon,Prevision,DateHeureMAJPrevision,DateHeurePrevision,planEau,nomBassin,messageParticulier,mesageErreur,typePrevision&returnGeometry=false&where=troncon=`,
      M2: `https://services3.arcgis.com/0lL78GhXbg1Po7WO/arcgis/rest/services/FS_PROD_Median_Jour2/FeatureServer/101/query/?f=json&outFields=Troncon,Prevision,DateHeureMAJPrevision,DateHeurePrevision,planEau,nomBassin,messageParticulier,mesageErreur,typePrevision&returnGeometry=false&where=troncon=`,
      F1: `/apis/esri3-feature-services/0lL78GhXbg1Po7WO/arcgis/rest/services/FS_PROD_Fort_Jour1/FeatureServer/101/query/?f=json&outFields=Troncon,Prevision,DateHeureMAJPrevision,DateHeurePrevision,planEau,nomBassin,messageParticulier,mesageErreur,typePrevision&&returnGeometry=false&where=troncon=`,
      F2: `/apis/esri3-feature-services/0lL78GhXbg1Po7WO/arcgis/rest/services/FS_PROD_Fort_Jour2/FeatureServer/101/query/?f=json&outFields=Troncon,Prevision,DateHeureMAJPrevision,DateHeurePrevision,planEau,nomBassin,messageParticulier,mesageErreur,typePrevision&&returnGeometry=false&where=troncon=`,
    },
    withCredentials: true
  },
  igo : Object.assign( environmentBase.igo, {
    auth: {
      url: '/apis/users',
      tokenKey: 'id_token_igo',
      allowAnonymous: false,
      trustHosts: [],
      homeRoute: "/",
      profilsGuard: [
        "GRAPP-VIG-PARTENAIRE_MO",
        "GRAPP-VIG-CONS_SC_SSO",
        "GRAPP-VIG-PILOTE_COG",
        "GRAPP-VIG-OMSC_ANALYSTE",
        "GRAPP-URGENCE-UTILISATEUR"
      ]
    },
    context:{
      defaultContextUri: 'dev'
    }
  })
});
